/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface StreamlineIRRConfigParamsSpec { 
    service_type: ServiceTypeEnum;
    org_ids?: Array<string>;
    /**
     * If executed in dry run mode, DB and IRR will not be updated but assumed success.
     */
    dry_run?: boolean;
    /**
     * If True, update IRRs with old scheme FQDN to new scheme FQDN.
     */
    streamline_fqdn?: boolean;
    /**
     * If True, update all IRRs with Operator org as Support org.
     */
    streamline_support_org?: boolean;
}
export namespace StreamlineIRRConfigParamsSpec {
}


